import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import { CrudBuilderConfig } from '@core/components/crudbuilder/models/crud-builder-config';
import { FallbackImagesService } from '@core/services/fallback-images/fallback-images.service';
import { AlertController, Platform } from '@ionic/angular';
import { AvatarUploadService } from '@core/services/avatar-upload/avatar-upload.service';
import { config } from '../../../config/config';
import { PeopleService } from '@core/state/people';
import { FormatService } from '@core/services/format/format.service';
import { PopularAppStatesService } from '@core/services/popular-app-states/popular-app-states.service';
import { Router } from '@angular/router';
import { BreadBuilderService } from '@core/services/bread-builder/bread-builder.service';
import { FieldConfig } from '@core/components/crudbuilder/models/field-config';
import { zip } from 'rxjs';
import { CommonToastsService } from '@core/services/common-toasts/common-toasts.service';

@Component({
  selector   : 'app-readbuilder',
  templateUrl: './readbuilder.component.html',
  styleUrls  : ['./readbuilder.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReadbuilderComponent implements OnInit, OnChanges {

  @Input() config: CrudBuilderConfig = null;
  @Input() model: any                = {};

  public id;
  public FieldConfig  = FieldConfig;

  public ready = false;
  public prefetching = false;
  public gender = {
    0:"Man",
    1:"Vrouw"
  };

  constructor(
    public fallbackImages: FallbackImagesService,
    public platform: Platform,
    private avatarUpload: AvatarUploadService,
    private peopleService: PeopleService,
    private alertController: AlertController,
    public format: FormatService,
    public states: PopularAppStatesService,
    private router: Router,
    public bread: BreadBuilderService,
    private cdr: ChangeDetectorRef,
    private toast: CommonToastsService,
  ) {
  }

  ngOnInit() {
    console.log(this.config);

    this.prefetch();
  }

  prefetch() {
    if (!this.prefetching) {
      this.ready = false;
      this.prefetching = true;
      // Find fields that need a query on the server, then mark as ready.
      const subs = this.states.prefetchRead(this.config.readFields, this.model);
      subs.subscribe(() => {
        console.log('ready');
        this.ready = true;
        this.prefetching = false;
        console.log(this.ready);
        this.cdr.detectChanges();
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.prefetch();
  }

  // People Avatar Upload Stuff
  // TODOLATER: Might want to refactor this, as upload functionality should not be on the ReadBuilder.
  async uploadAvatar() {
    if (this.platform.is('cordova') && (this.platform.is('android') || this.platform.is('ios'))) {
      this.uploadAvatarUsingMobile();
    } else if (this.platform.is('desktop')) { // check if browser
      this.uploadAvatarFromBrowser();
    } else {
      this.presentAlert('This platform is not supported for uploading image');
    }
  }

  async uploadAvatarUsingMobile() {
    this.toast.error('Uploading...');
    this.avatarUpload.pickImageFromMobile()
      .then(results => {
        let newImage = results[0];

        this.avatarUpload.uploadFileFromMobile(
          newImage,
          `${config.api.host}/api/people/${this.model.id}/files?type=avatar`,
        ).then((data) => {
          this.refreshPeople();
        }).catch(err => {
          this.presentAlert('Uploading image failed.');
          this.toast.error('Failed!');
        });
      })
      .catch((err) => {
        this.presentAlert('Something went wrong getting image.');
      });
  }

  async uploadAvatarFromBrowser() {
    let file = await this.avatarUpload.browseFileFromBrowser();

    const formData = new FormData();
    formData.append('file', file as Blob);

    this.peopleService.uploadWeb(this.model.id, formData)
      .subscribe(result => {
        this.refreshPeople();
      }, err => {
        this.presentAlert('Upload failed');
      });
  }

  async presentAlert(message) {
    const alert = await this.alertController.create({
      header : 'Alert',
      message: message,
      buttons: ['OK']
    });

    await alert.present();
  }

  refreshPeople(event = null) {
    this.peopleService.get().subscribe(() => {
      this.toast.success('Uploaded...');
      if (event) {
        event.target.complete();
      }
    });
  }

  back() {
    this.router.navigateByUrl(
      this.bread.getBrowseLink(this.config)
    );
  }

}
